import { legacyBreakpoints } from '@carvana/merch-tailwind/breakpoints';
import styled from 'styled-components';
import { stickyBannerZIndex } from '~/constants/vdp/zIndex';

export const stickyBannerHeightMobile = 104;
export const stickyBannerHeightDesktop = 116;

export const Wrapper = styled.div.attrs({
  className:
    'bg-white fixed flex justify-between max-w-[1800px] mx-auto w-full l:px-32'
})`
  height: ${stickyBannerHeightMobile}px;
  top: ${stickyBannerHeightMobile * -1}px;

  transition: 0.3s top ease-in-out;
  z-index: ${stickyBannerZIndex};

  @media (min-width: ${legacyBreakpoints.m}px) {
    height: ${stickyBannerHeightDesktop}px;
    top: ${stickyBannerHeightDesktop * -1}px;
  }
`;
